// Shared helper for generating/extracting a correlation ID.
// Used by client fetch wrapper, SSR middleware, and logging.
export const REQUEST_ID_HEADER = "x-request-id";

export function generateRequestId(): string {
  // crypto.randomUUID is available in browsers, workers, and Node 19+
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `req_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function extractRequestId(headers: Headers): string {
  return headers.get(REQUEST_ID_HEADER) || generateRequestId();
}
